const apiUrl = "https://cefalotechdailyapi.azurewebsites.net/api/";
//const apiUrl = "https://techdailybackend.azurewebsites.net/api/v1/"
//const apiUrl = "https://localhost:7010/api/";
//const apiUrl = "https://localhost:3000/api/v1/";
export default apiUrl;